/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./sticky-bottom.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./sticky-bottom.component";
import * as i3 from "../../shared/window.service";
var styles_StickyBottomComponent = [i0.styles];
var RenderType_StickyBottomComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_StickyBottomComponent, data: {} });
export { RenderType_StickyBottomComponent as RenderType_StickyBottomComponent };
export function View_StickyBottomComponent_0(_l) { return i1.ɵvid(0, [i1.ɵqud(402653184, 1, { parent: 0 }), i1.ɵqud(402653184, 2, { content: 0 }), (_l()(), i1.ɵeld(2, 0, [[1, 0], ["parent", 1]], null, 2, "div", [], null, null, null, null, null)), (_l()(), i1.ɵeld(3, 0, [[2, 0], ["content", 1]], null, 1, "div", [], null, null, null, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_StickyBottomComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-sticky-bottom", [], null, [["window", "touchmove"], ["window", "scroll"], ["window", "resize"], ["window", "orientationchange"]], function (_v, en, $event) { var ad = true; if (("window:touchmove" === en)) {
        var pd_0 = (i1.ɵnov(_v, 1).checkAndMakeSticky($event) !== false);
        ad = (pd_0 && ad);
    } if (("window:scroll" === en)) {
        var pd_1 = (i1.ɵnov(_v, 1).checkAndMakeSticky($event) !== false);
        ad = (pd_1 && ad);
    } if (("window:resize" === en)) {
        var pd_2 = (i1.ɵnov(_v, 1).checkAndMakeSticky($event) !== false);
        ad = (pd_2 && ad);
    } if (("window:orientationchange" === en)) {
        var pd_3 = (i1.ɵnov(_v, 1).checkAndMakeSticky($event) !== false);
        ad = (pd_3 && ad);
    } return ad; }, View_StickyBottomComponent_0, RenderType_StickyBottomComponent)), i1.ɵdid(1, 4505600, null, 0, i2.StickyBottomComponent, [i3.WindowService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var StickyBottomComponentNgFactory = i1.ɵccf("lp2-sticky-bottom", i2.StickyBottomComponent, View_StickyBottomComponent_Host_0, {}, {}, ["*"]);
export { StickyBottomComponentNgFactory as StickyBottomComponentNgFactory };
//# sourceMappingURL=sticky-bottom.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/footer/sticky-bottom/sticky-bottom.component.ngfactory.js
// module id = 1447
// module chunks = 27 28 29